// @flow
import React, { Component } from "react";

import type { ErrorsType } from "../../types/UserFormType";
import { ErrosDisplay } from "../../containers/ErrosDisplay";
import { StyledTextField, StyledSelect, CancelButton, SubmitButton } from "imagus-components";

import Grid from "@material-ui/core/Grid";

type UserProfileFormStatesType = {
  errors: ErrorsType,
  loading: boolean,
  firstName: string,
  lastName: string,
  facebaseUid: string
};

type UserProfileFormPropsType = {
  user: { [key: string]: * },
  onClose: Function,
  setUpdateUser: Function
};

class UserProfileForm extends Component<UserProfileFormStatesType, UserProfileFormPropsType> {
  constructor(props: UserProfileFormPropsType) {
    super(props);
    this.submit = this.submit.bind(this);
    this.state = {
      errors: {},
      loading: false,
      firstName: props.user.firstName || "",
      lastName: props.user.lastName || "",
      facebaseUid: props.user.defaultFacebase.uuid
    };
  }

  handleChange = (e: Event): * => {
    const name = e.target.name;
    const value = e.target.value;
    this.setState((state: UserProfileFormStatesType): UserProfileFormStatesType => ({
      [name]: value
    }));
  }

  submit = async (e: Event): * => {
    e.preventDefault();
    e.stopPropagation();
    const errors = this.state.errors;

    if (Object.keys(errors).length === 0) {
      this.setState((): * => ({ "loading": true }));
      this.props.setUpdateUser(
        this.state.firstName,
        this.state.lastName,
        this.state.facebaseUid,
        this.submitDone,
        this.submitFail
      );
    }
  }

  submitDone = () => {
    this.props.onClose();
  }

  submitFail = (errors: ErrorsType): * => {
    this.setState({
      errors: errors,
      loading: false
    });
  }

  render(): React$Element<*> {
    const errors = this.state.errors;
    const loading = this.state.loading;

    let facebases = [];
    this.props.user.facebases.map((facebase: *, i: number): * => {
      facebases.push({ value: facebase.uuid, label: facebase.name });
    });

    return (
      <form onSubmit={(!loading && this.submit) || undefined}>
        <Grid container spacing={8}>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="First Name"
              name="firstName"
              value={this.state.firstName}
              onChange={this.handleChange}
              inpuType="text"
            />
          </Grid>
          <Grid item xs={12}>
            <StyledTextField
              isRequired={true}
              label="Last Name"
              name="lastName"
              value={this.state.lastName}
              onChange={this.handleChange}
              inpuType="text"
            />
          </Grid>
          <Grid item xs={12}>
            <StyledSelect
              value={this.state.facebaseUid}
              onChange={this.handleChange}
              name="facebaseUid"
              label="System"
              isRequired={false}
              menus={facebases}
              isStyled
              isInvalid={errors.facebase !== undefined}
            />
          </Grid>
          <Grid item xs={12}>
            <ErrosDisplay errors={errors} form="user profile" />
          </Grid>
          <Grid item xs={12}>
            <div className="form-right-btn-block">
              <CancelButton onClick={this.props.onClose} />
              <SubmitButton loading={loading} disabled={Object.keys(errors).length > 0} />
            </div>
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default UserProfileForm;
